export default "__VITE_ASSET__BUkTLKdn__"